export default "__VITE_ASSET__C5Tfk3bU__"